import React from 'react'
import styles from './styles.module.scss'

export default function LoadingCartProduct() {
    return (
        <aside className={styles.container} />
    )
}
